import React from "react";
import "./index.css";
import Home from "./routes/Home"
import { Route, Routes } from "react-router-dom";


function App() {
  return (
     <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/about-content" element={<AboutContent />} /> */}

    </Routes>
  );
}

export default App;
